import React, { Fragment } from 'react';
import { history } from 'routes/history';
import { Header } from 'components/header/header';
import { connect } from 'react-redux';
import { ItemList } from 'components/itemList/itemList';
import './SigningContract.scss';
import HeadlineTitle from '../../componentsV2/HeadlineTitle/HeadlineTitle';
import { bindActionCreators } from 'redux';
import numberOneIcon from 'assets/icons/number-one.svg';
import numberTwoIcon from 'assets/icons/number-two.svg';
import numberThreeIcon from 'assets/icons/number-three.svg';

import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { NextStep } from './components/NextStep';
import { OKConsents } from 'gdpr-consents/components/OKConsents/OKConsents';
import { OKCONSENTS_POSITIVE_VALUE } from 'gdpr-consents/constants/constants';
import { ALLOW_COOKIE } from '../../constants';
import { recordEventCustomOnly, recordEventStepSuccess } from 'utilities/uTagging';
import { loanStatus } from '../../actions/aresActions';
import { formatText, HtmlText } from 'core/i18n';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { actions as formActions } from 'react-redux-form';
import preLoaderActions from 'actions/preLoaderActions';
import consentsActions from 'actions/consentsActions';
import { BASE_PATH } from 'constants/index';
import signActions from 'actions/signActions';
import modalCancelActions from 'actions/modalCancelActions';
import Storage from 'utilities/storage';
import { recordAndSavePage } from 'actions/errorViewNavigation';

class SigningContract extends React.Component {
    constructor(props) {
        super(props);
    }

    getConsentsData() {
        const { gdprConsents } = this.props;
        const consents = gdprConsents.get('consents');
        const newConsents = consents.map(cell => ({
            id: cell.getIn(['consentCell', 'id']),
            status: cell.get('status'),
        }));

        return {
            consents: newConsents,
            newCustomer: gdprConsents.get('newCustomer'),
        };
    }

    componentDidMount() {
        const { recordAndSavePage } = this.props;
        recordAndSavePage(
            '/onboarding/prestamo-aprobado/firma',
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            'ares',
            {
                tipoPagina: 'generica',
                tipoProceso: 'onboarding',
                pasoProceso: 'prestamo-aprobado',
                productoOnboardingDetalle: 'prestamo ares',
                detalleProceso: 'firma',
            }
        );
    }

    componentDidUpdate() {
        const { userProfile, sign } = this.props;
        if (userProfile.contract !== 'completed' || sign.get('status') !== 'completed') {
            this.onHandleShowPreloader();
            this.onHandleHidePreloader();
        }

        return true;
    }

    onHandleShowPreloader() {
        const { userProfile, signActions, preLoaderActions } = this.props;

        if (
            typeof userProfile.eventParam !== 'undefined' &&
            userProfile.eventParam === 'signing_complete' &&
            userProfile.accessToken
        ) {
            let checkStatusInterval;
            if (typeof this.checkStatusInterval === 'undefined') {
                checkStatusInterval = setInterval(() => {
                    signActions.getContractStatus(userProfile.accessToken);
                }, 3000);
                this.checkStatusInterval = checkStatusInterval;
            }
            setTimeout(() => {
                preLoaderActions.setInformationText(formatText('informationText-signing'));
                preLoaderActions.showPreLoader();
            }, 250);
        }
    }

    onHandleHidePreloader() {
        const { userProfile, preLoaderActions, sign } = this.props;

        if (userProfile.contract === 'completed' || sign.get('status') === 'completed') {
            clearInterval(this.checkStatusInterval);

            setTimeout(() => {
                preLoaderActions.hidePreLoader();
            }, 250);
        }
    }

    handleSubmit = () => {
        const { userProfile, consentsActions, preLoaderActions } = this.props;
        const accessToken = userProfile.accessToken;
        const data = this.getConsentsData();
        const infoArray = [
            formatText('button-contractGenerating'),
            formatText('button-contractWait'),
            formatText('button-contractVerifyData'),
            formatText('button-contractWait'),
            formatText('button-contractWriting'),
            formatText('button-contractWait'),
            formatText('button-contractAuthenticating'),
            formatText('button-contractWait'),
        ];

        preLoaderActions.setInformationArray(infoArray);
        preLoaderActions.showPreLoader();

        if (data.consents.length <= 0) {
            this.handleCreateContract(accessToken);

            return;
        }

        recordEventCustomOnly({
            categoriaEvento: 'interaccion en firma',
            accionEvento: 'continuar',
        });

        consentsActions.sendConsents(accessToken, data, valid => {
            if (!valid) {
                history.push(`${BASE_PATH}/errors`);

                return;
            }

            this.handleCreateContract(accessToken);
        });
    };

    handleCreateContract = accessToken => {
        const { signActions } = this.props;

        signActions.loadingContract();

        signActions.createContract(accessToken, (sessionExpired, serverError, error) => {
            if (error || sessionExpired || serverError) {
                history.push(`${BASE_PATH}/errors`);
            } else {
                if (ALLOW_COOKIE && Storage.cookies.get('accessToken')) {
                    Storage.cookies.remove('accessToken');
                }
                window.location.href = this.props.sign.get('contractUrl');
            }
        });
    };

    isSignComeback = () => {
        const { userProfile } = this.props;

        if (userProfile.contract === 'completed') {
            recordEventStepSuccess(userProfile.investmentType, '/onboarding/contrato/', 'firma de contrato');
        }

        return (
            userProfile.contract === 'completed' ||
            (typeof userProfile.eventParam !== 'undefined' &&
                (userProfile.eventParam === 'signing_complete' || userProfile.eventParam === 'viewing_complete'))
        );
    };

    handleChangeValue = (consentId, value) => {
        recordEventCustomOnly({
            categoriaEvento: 'interaccion en firma',
            accionEvento: consentId,
            etiquetaEvento: value === OKCONSENTS_POSITIVE_VALUE ? 'si' : 'no',
        });
    };

    handleAcceptAll = checked => {
        recordEventCustomOnly({
            categoriaEvento: 'interaccion en firma',
            accionEvento: 'acepto todas las finalidades',
            etiquetaEvento: checked === OKCONSENTS_POSITIVE_VALUE ? 'checked' : 'unchecked',
        });
    };

    handleCancelAction = () => {
        const { modalCancelActions } = this.props;
        modalCancelActions.showModalCancel();

        recordEventCustomOnly({
            categoriaEvento: 'interaccion en firma',
            accionEvento: 'salir',
        });
    };

    render() {
        const { getLoanStatus } = this.props;

        return (
            <React.Fragment>
                <div className="prospects-content">
                    <Header showContinueProcess={false} />

                    {this.isSignComeback() ? (
                        <div className="prospects-content">
                            <div className="basic-layering">
                                <MessagesScreen
                                    iconClass="icons icons--icon-checked"
                                    title={formatText('messagesScreen-signedSuccessfullyTitle')}
                                    buttonText={formatText('button-continue')}
                                    showRoadmapNavigation={true}
                                    roadmapNavigationProps={{
                                        buttonPrevHidden: true,
                                        buttonContinueAction: () => getLoanStatus(),
                                    }}
                                >
                                    {formatText('messagesScreen-signedInfo')}
                                </MessagesScreen>
                                <WelcomeCard />
                            </div>
                        </div>
                    ) : (
                        <Fragment>
                            <HeadlineTitle
                                icon="fioc"
                                text="contentStepsTitles-signContract"
                                subtitle="contentStepsTitles-yourSignature"
                            />
                            <div className="content-container">
                                <ItemList
                                    title={formatText('contentStepsTitles-whatSign')}
                                    items={[
                                        formatText('signingPage-subscriptionDescription_ares'),
                                        formatText('signingPage-brochureDescriptionTC'),
                                        formatText('signingPage-gdprLegalIndex1_ares'),
                                        formatText('signingPage-precontractualDescription_ares'),
                                        formatText('signingPage-contract_ares'),
                                    ]}
                                />
                                <div className="purposes-container">
                                    <OKConsents
                                        placementId="interstitial"
                                        showChannels={false}
                                        handleAcceptAll={this.handleAcceptAll}
                                        handleChangeValue={this.handleChangeValue}
                                    />
                                    <div className="purpose-subtext">
                                        <p>{HtmlText(formatText('gdpr-interstitialNeutral'))}</p>
                                    </div>
                                </div>

                                <div className="docusign-advise">
                                    <p>{formatText('signingPage-brokerOpenbankDocuSign')}</p>
                                </div>

                                <div className="next-steps-container">
                                    <NextStep
                                        icon={numberOneIcon}
                                        title={'signingPage-firm'}
                                        description={'signingPage-firmDescription'}
                                    />
                                    <NextStep
                                        icon={numberTwoIcon}
                                        title={'signingPage-SMSCode'}
                                        description={'signingPage-SMSCodeDescription'}
                                    />
                                    <NextStep
                                        icon={numberThreeIcon}
                                        title={'signingPage-customerLogin'}
                                        description={'signingPage-customerLoginDescription'}
                                    />
                                </div>
                            </div>
                            <div className="footer">
                                <RoadmapNavigation
                                    buttonPrevHidden
                                    buttonFinalizeHidden={false}
                                    buttonFinalizeText={formatText('button-finalize')}
                                    buttonContinueAction={this.handleSubmit}
                                    buttonCancelAction={this.handleCancelAction}
                                />
                            </div>
                        </Fragment>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default connect(
    state => ({
        userProfile: state.userProfile,
        gdprConsents: state.gdprConsents,
        sign: state.sign,
    }),
    dispatch => ({
        getLoanStatus: bindActionCreators(loanStatus, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        consentsActions: bindActionCreators(consentsActions, dispatch),
        signActions: bindActionCreators(signActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(SigningContract);
